<template>
	<div class="medication-information">
    <div v-show="!monograph.data.Ndc">
      <p>{{loadingText}}</p>
    </div>

    <div v-if="monograph.data.Ndc" class="monograph">
      <h5 class="title">{{ monograph.data.Ln }}</h5>
        <div id="image_wrapper"  class="has-text-centered">
            <img v-bind:src="monograph.data.ImageUrl" :alt="noImageText"/>
        </div>

        <div class="info">
        <h6 id="label_warning">{{labelWarningText}}</h6>
        <p>{{ monograph.data.LabelWarning || emptyText }}</p>

        <h6 id="disclaimer">{{importantText}}</h6>
        <p>{{ monograph.data.Disclaimer || emptyText }}</p>

        <h6 id="common_brand_names">{{commonBrandNamesText}}</h6>
        <p>{{ monograph.data.CommonBrands || emptyText }}</p>

        <h6 id="uses">{{usesText}}</h6>
        <p>{{ monograph.data.Uses || emptyText }}</p>

        <h6 id="side_effects">{{sideEffectsText}}</h6>
        <p>{{ monograph.data.SideEffects || emptyText }}</p>

        <h6 id="precautions">{{precautionsText}}</h6>
        <p>{{ monograph.data.Precautions || emptyText }}</p>

        <h6 id="drug_interactions">{{drugInteractionsText}}</h6>
        <p>{{ monograph.data.DrugInteraction || emptyText }}</p>

        <h6 id="food_interactions">{{foodInteractionsText}}</h6>
        <p>{{ monograph.data.FoodInteraction || emptyText }}</p>

        <h6 id="overdose">{{overdoseText}}</h6>
        <p>{{ monograph.data.Overdose || emptyText }}</p>

        <h6 id="missed_dose">{{missedDoseText}}</h6>
        <p>{{ monograph.data.MissedDose || emptyText }}</p>

        <h6 id="storage">{{storageText}}</h6>
        <p>{{ monograph.data.Storage || emptyText }}</p>

        <h6 id="notes">{{notesText}}</h6>
        <p>{{ monograph.data.Notes || emptyText }}</p>
      </div>
    </div>
      
	</div>
</template>

<script>
    import MedicationMonograph from "../models/MedicationMonograph.js";
    import Default from "../models/Default.js";

export default {
    props: [
        "ndc"
    ],
    data: function () {
        console.log("HERE", this);
        return {
            emptyText: "",
            loadingText: "",
            labelWarningText: "",
            importantText: "",
            commonBrandNamesText: "",
            usesText: "",
            sideEffectsText: "",
            precautionsText: "",
            drugInteractionsText: "",
            foodInteractionsText: "",
            overdoseText: "",
            missedDoseText: "",
            storageText: "",
            notesText: "",
            noImageText: ""
        };
    },
    computed: {
        message: function () {
            return this.getDefault("message").replace("${interaction_id}", this.ndc);
        }
    },
    asyncComputed: {
        monograph: {
            get: function () {
                return MedicationMonograph.get(this.ndc);
            },
            default: {
                data: {}
            }
        }
        },
        created: function () {
            this.loadDefaults();
        },
        methods: {
            loadDefaults: function () {
                var me = this;

                Default.GetForView("medication").then(function (res) {
                    me.defaults = res.data;
                    me.loadText();
                });
            },
            getDefault: function (nameKey) {
                return Default.Find(nameKey, this.defaults);
            },
            loadText: function () {
                this.noImageText = this.getDefault("no_image")
                this.emptyText = this.getDefault("none");
                this.loadingText = this.getDefault("loading");
                this.labelWarningText = this.getDefault("label_warning");
                this.importantText = this.getDefault("important");
                this.commonBrandNamesText = this.getDefault("common_brand_names");
                this.usesText = this.getDefault("uses");
                this.sideEffectsText = this.getDefault("side_effects");
                this.precautionsText = this.getDefault("precautions");
                this.drugInteractionsText = this.getDefault("drug_interactions");
                this.foodInteractionsText = this.getDefault("food_interactions");
                this.overdoseText = this.getDefault("overdose");
                this.missedDoseText = this.getDefault("missed_dose");
                this.storageText = this.getDefault("storage");
                this.notesText = this.getDefault("notes");
            }
        }
};
</script>



// WEBPACK FOOTER //
// MedicationInformation.vue?f6444394